import { useState } from 'react'
import { useAuth } from '@/hooks/use-auth'
import { Button } from '@/components/ui/button'
import { AlertCircle } from 'lucide-react'
import { toast } from '@/lib/toast'

export function EmailVerificationBanner() {
  const { user, resendVerificationEmail, isLoading } = useAuth()
  const [isResending, setIsResending] = useState(false)

  if (!user || user.emailVerified) {
    return null
  }

  const handleResendEmail = async () => {
    setIsResending(true)
    try {
      await resendVerificationEmail()
      toast.success('Verification email sent successfully!')
    } catch (error) {
      console.error('Failed to resend verification email:', error)
      toast.error('Failed to send verification email. Please try again.')
    } finally {
      setIsResending(false)
    }
  }

  return (
    <div className="bg-background z-50 rounded-md border px-4 py-3 mb-6">
      <div className="flex flex-col justify-between gap-3 md:flex-row md:items-center">
        <div className="flex items-start gap-3">
          <AlertCircle className="h-5 w-5 mt-0.5 text-muted-foreground flex-shrink-0 text-blue-600" />
          <p className="text-sm">
            We've sent a verification email to <strong>{user.email}</strong>.
            Please check your inbox and click the link to verify your account.
          </p>
        </div>
        <Button
          size="sm"
          onClick={handleResendEmail}
          disabled={isResending || isLoading}
          className="bg-black text-white dark:bg-white dark:text-black border border-gray-200 hover:bg-gray-800 dark:hover:bg-gray-200"
        >
          {isResending ? 'Sending...' : 'Resend Email'}
        </Button>
      </div>
    </div>
  )
}
